import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a7ad91d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5a7ad91d&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ad91d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a7ad91d')) {
      api.createRecord('5a7ad91d', component.options)
    } else {
      api.reload('5a7ad91d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5a7ad91d&scoped=true", function () {
      api.rerender('5a7ad91d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/member/index.vue"
export default component.exports